module.exports = __webpack_public_path__ + "static/media/haitao3.c5f1c053.jpg";